import { classNames } from '../UNSAFE_classNames';
import { styles } from './DragAndDropStyles.css';

/**
 * A helper function that returns the dragImage.
 */
export const createDragImage = (dragTarget: HTMLElement, dragImageClasses: string) => {
  const dragImage = dragTarget.cloneNode(true) as HTMLElement;
  dragImage.className = classNames([dragImageClasses, styles.draggerPositionStyles]);
  dragImage.style.width = dragTarget.offsetWidth + 'px';
  document.body.appendChild(dragImage);
  return dragImage;
};
